import { ValueOf } from 'shared/types/generic'
import { formatInTimeZone } from 'shared/utils/date'

export const MIN_CUSTOMER_AGE = 13
export const ADULT_CUSTOMER_AGE = 18

export const CustomerAgeStatus = {
  adult: 'adult',
  underage: 'underage',
  unknown: 'unknown',
} as const

export type CustomerAgeStatus = ValueOf<typeof CustomerAgeStatus>

export const getCustomerAgeStatus = (dateOfBirth?: string | null): CustomerAgeStatus => {
  const match = dateOfBirth?.match(/^(\d{4})-(\d{2})-(\d{2})/)

  if (!match) return CustomerAgeStatus.unknown

  const [, year, month, day] = match
  // Compare Warsaw calendar dates so SSR (UTC) and the browser agree around midnight
  const today = formatInTimeZone(new Date(), 'Europe/Warsaw', 'sv-SE', { year: 'numeric', month: '2-digit', day: '2-digit' })
  const adultDate = `${Number(year) + ADULT_CUSTOMER_AGE}-${month}-${day}`

  return today >= adultDate ? CustomerAgeStatus.adult : CustomerAgeStatus.underage
}

export const validateMaxValueDateOfBirth = (value?: string) => {
  if (!value) {
    return true
  }

  const dobDate = new Date(value)
  const today = new Date()

  const minAgeDate = new Date()

  minAgeDate.setFullYear(today.getFullYear() - MIN_CUSTOMER_AGE)

  if (dobDate > minAgeDate) {
    return false
  }

  return true
}
